import styled, { keyframes } from 'styled-components';

const reveal = keyframes`
	from 				{opacity: 0;}
	to 					{opacity: 1;}
`;

export const ResultWrapper = styled('div')`
  cursor: pointer;
`;

export const Wrapper = styled('section')`
  text-align: center;
  opacity: 0;
  animation: ${reveal} 0.8s linear forwards;
  padding: ${({ theme }) => `0 ${theme.x3spacePx}px`};
  > h3 {
    ${({ theme }) => theme.typography.smallStrong}
    margin: ${({ theme }) => theme.x2spacePx}px 0 ${({ theme }) =>
      theme.x1spacePx}px;
  }
  > p {
    opacity: 0.5;
    ${({ theme }) => theme.typography.xSmall}
  }
`;

export const Search = styled('div')`
  max-width: 400px;
  margin: 0 auto;
`;
